/**
 * CSS alone can't force a <details> open (the closed state is a UA behaviour),
 * so on print we open every disclosure and restore it afterwards. This makes a
 * save-as-PDF capture the FULL record — every product's ingredients + history
 * and every metric definition — not just what the viewer had expanded.
 */
let installed = false

export function installPrintExpand(): void {
  if (installed || typeof window === 'undefined') return
  installed = true

  const reopened: HTMLDetailsElement[] = []

  const expand = () => {
    reopened.length = 0
    document.querySelectorAll('details').forEach((d) => {
      if (!d.open) {
        d.open = true
        reopened.push(d)
      }
    })
  }
  const restore = () => {
    reopened.forEach((d) => {
      d.open = false
    })
    reopened.length = 0
  }

  window.addEventListener('beforeprint', expand)
  window.addEventListener('afterprint', restore)
  // Safari fires matchMedia('print') rather than before/afterprint reliably.
  const mql = window.matchMedia('print')
  mql.addEventListener?.('change', (e) => (e.matches ? expand() : restore()))
}
